import { render, staticRenderFns } from "./MarketInsights.vue?vue&type=template&id=7b942fe6&"
import script from "./MarketInsights.vue?vue&type=script&lang=js&"
export * from "./MarketInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports